/**
 * Landing-page view of the shared mobile-app constants. The proxy owns the
 * redirect; the page only orders its buttons, using the same device sniff as
 * the in-page app banner (which adds the iPadOS-as-Mac touch check) without
 * the banner's Safari exclusion: the buttons still lead with the App Store there.
 */
import { detectMobileStorePlatform } from '@/lib/mobile-app-banner';

export { APP_STORE_URL, GOOGLE_PLAY_URL, type MobilePlatform } from '@/lib/mobile-app';

/** Which store to lead with in the browser, or null to keep the default order. */
export function detectMobilePlatform(nav: Navigator) {
	return detectMobileStorePlatform({
		userAgent: nav.userAgent,
		platform: nav.platform,
		maxTouchPoints: nav.maxTouchPoints,
	});
}
